var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyCandidateProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2053_83820)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#48CAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6821 35.6295L38.2752 12.2025L28.3765 11.0476V39.754L51.1436 57.5718C59.7226 51.7645 63.0221 41.5688 63.6821 35.6295Z",
    fill: "#00B4D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4355 54.3104C51.4355 55.4658 51.3355 56.5979 51.1437 57.6984C47.0192 60.5416 41.5749 63.8411 31.8411 64.0061C21.9423 63.8411 16.498 60.2116 12.4899 57.407C12.3297 56.3983 12.2466 55.3641 12.2466 54.3104C12.2466 43.4887 21.0193 34.7159 31.8411 34.7159C42.6628 34.7159 51.4355 43.4887 51.4355 54.3104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.841,
    cy: 21.6529,
    r: 11.4301,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 63,
    rx: 31.5,
    stroke: "#48CAE4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2053_83820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCandidateProfile);
export default __webpack_public_path__ + "static/media/Empty_candidate_profile.8f8842a8227908a861b538ab74bc25e5.svg";
export { ForwardRef as ReactComponent };